/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV6RealGiftContract) return;

  const MODE = 'personalized_real_gifts';
  const GROUP = '_safewalk_package_group';
  const ROLE = '_safewalk_package_role';
  const REAL = '_safewalk_real_gift';
  const KACHING = '__kaching_bundles';
  const ROLES = ['gift_tags', 'gift_dispenser', 'gift_roll'];
  const KINDS = ['harness_only', 'harness_bungee', 'full_set'];
  const copy = () => window.SafeWalkV6RealGiftCopy || {};
  const dogProperty = () => copy().dogNameProperty || 'שם הכלב';
  const phoneProperty = () => copy().phoneProperty || 'מספר טלפון';
  const validationKey = ({ phone } = {}) => {
    const normalizedPhone = String(phone || '').trim();
    if (!normalizedPhone) return '';
    const digits = normalizedPhone.replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15 ? '' : 'phoneError';
  };
  const propertiesFor = (item) => item?.properties && typeof item.properties === 'object'
    ? item.properties
    : {};
  const lineTotal = (item) => Number.isFinite(Number(item?.final_line_price))
    ? Number(item.final_line_price)
    : Number(item?.final_price || 0) * Number(item?.quantity || 1);
  const originalTotal = (item) => Number.isFinite(Number(item?.original_line_price))
    ? Number(item.original_line_price)
    : Number(item?.original_price || 0) * Number(item?.quantity || 1);
  const variantId = (item) => Number(item?.variant_id || item?.id || 0);
  const productId = (item) => Number(item?.product_id || 0);
  const parentKey = (item) => String(item?.parent_relationship?.parent_key || '');
  const metadataFor = (item) => {
    const raw = propertiesFor(item)[KACHING];
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  };
  const hasRealMarker = (item) =>
    String(propertiesFor(item)[REAL] || '').toLowerCase() === 'true';
  const isMarkedGift = (item) => {
    const properties = propertiesFor(item);
    return hasRealMarker(item)
      && Boolean(String(properties[GROUP] || '').trim())
      && ROLES.includes(properties[ROLE]);
  };
  const identityFor = (config, role) => (config.identities || [])
    .find((identity) => identity.role === role);
  const itemMatchesIdentity = (item, identity) => Boolean(identity)
    && productId(item) === Number(identity.productId)
    && variantId(item) === Number(identity.variantId);
  const completeGiftIds = (ids = {}) => ROLES.every((role) => Boolean(ids[role]))
    && new Set(ROLES.map((role) => ids[role])).size === ROLES.length;
  const validateConfig = (config = {}) => {
    if ((config.mode || MODE) !== MODE) return true;
    const identities = config.identities || [];
    const identitiesValid = identities.length === ROLES.length
      && ROLES.every((role) => identities.filter((item) => item.role === role).length === 1)
      && identities.every((item) => Number(item.productId) > 0 && Number(item.variantId) > 0)
      && new Set(identities.map((item) => Number(item.productId))).size === ROLES.length
      && new Set(identities.map((item) => Number(item.variantId))).size === ROLES.length;
    return identitiesValid
      && Number(config.qualifyingProductId) > 0
      && Number(config.currentProductId) === Number(config.qualifyingProductId)
      && Boolean(config.deal)
      && KINDS.every((kind) => Boolean(config.bars?.[kind])
        && completeGiftIds(config.realGiftIds?.[kind]));
  };
  const readRootConfig = (root) => {
    const identity = (role, prefix) => ({
      role,
      productId: Number(root?.dataset[`${prefix}ProductId`] || 0),
      variantId: Number(root?.dataset[`${prefix}VariantId`] || 0)
    });
    const giftIds = (prefix) => ({
      gift_tags: root?.dataset[`${prefix}TagGiftId`] || '',
      gift_dispenser: root?.dataset[`${prefix}DispenserGiftId`] || '',
      gift_roll: root?.dataset[`${prefix}RollGiftId`] || ''
    });
    return {
      mode: root?.dataset.giftMode || window.SafeWalkV6GiftMode,
      currentProductId: Number(root?.dataset.currentProductId || 0),
      qualifyingProductId: Number(root?.dataset.realQualifyingProductId || 0),
      deal: root?.dataset.kachingDealId || '',
      bars: {
        harness_only: root?.dataset.kachingP1BarId || '',
        harness_bungee: root?.dataset.kachingP2BarId || '',
        full_set: root?.dataset.kachingP3BarId || ''
      },
      identities: [
        identity('gift_tags', 'realTagGift'),
        identity('gift_dispenser', 'realDispenserGift'),
        identity('gift_roll', 'realRollGift')
      ],
      realGiftIds: {
        harness_only: giftIds('kachingP1'),
        harness_bungee: giftIds('kachingP2'),
        full_set: giftIds('kachingP3')
      }
    };
  };
  const configFromRoot = (root) => {
    const base = readRootConfig(root);
    const kind = root?.swv5Purchase?.getPackageState?.()?.kind || 'harness_only';
    return {
      ...base,
      kind,
      barId: base.bars[kind] || '',
      giftIds: base.realGiftIds[kind] || {}
    };
  };
  const configFromRegistry = () => {
    const registry = window.SafeWalkV6RealGiftRegistry || {};
    return {
      ...registry,
      currentProductId: Number(registry.qualifyingProductId || 0)
    };
  };
  const mainContractProperties = (config, groupId) => {
    const result = {
      [GROUP]: String(groupId),
      [ROLE]: 'main',
      _safewalk_real_deal: config.deal,
      _safewalk_real_bar: config.barId,
      _safewalk_real_qualifying_product: String(config.qualifyingProductId)
    };
    (config.identities || []).forEach((identity) => {
      const slug = identity.role === 'gift_tags' ? 'tag' : identity.role.replace('gift_', '');
      result[`_safewalk_real_${slug}_product`] = String(identity.productId);
      result[`_safewalk_real_${slug}_variant`] = String(identity.variantId);
      result[`_safewalk_real_${slug}_entry`] = String(config.giftIds?.[identity.role] || '');
    });
    return result;
  };
  const giftContractProperties = (config, role, privateId) => ({
    _safewalk_real_deal: config.deal,
    _safewalk_real_bar: config.barId,
    _safewalk_real_entry: String(config.giftIds?.[role] || ''),
    _safewalk_real_private: String(privateId || '')
  });
  const classifyCart = (cart, config = {}) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const realMarked = items.filter(hasRealMarker);
    const groupIds = new Set();
    items.forEach((item) => {
      const properties = propertiesFor(item);
      if (properties[ROLE] === 'main' || hasRealMarker(item)) {
        const id = String(properties[GROUP] || '');
        if (id) groupIds.add(id);
      }
    });
    const validGiftKeys = new Set();
    const invalidGiftItems = realMarked.filter((item) => !isMarkedGift(item));
    const groups = [...groupIds].map((groupId) => {
      const mains = items.filter((item) => {
        const properties = propertiesFor(item);
        return properties[ROLE] === 'main' && String(properties[GROUP] || '') === groupId;
      });
      const main = mains.length === 1 ? mains[0] : null;
      const gifts = realMarked.filter((item) => String(propertiesFor(item)[GROUP]) === groupId);
      const kind = propertiesFor(main)._safewalk_package;
      const expectedBar = config.bars?.[kind] || '';
      const expectedGiftIds = config.realGiftIds?.[kind] || {};
      const mainMetadata = metadataFor(main);
      const privateId = String(mainMetadata?.id || '');
      const returnedBar = kind === 'harness_only' ? mainMetadata?.bid : mainMetadata?.bar;
      const mainValid = Boolean(main)
        && mains.length === 1
        && KINDS.includes(kind)
        && productId(main) === Number(config.qualifyingProductId)
        && Number(main.quantity) === 1
        && lineTotal(main) > 0
        && !propertiesFor(main)[dogProperty()]
        && !propertiesFor(main)[phoneProperty()]
        && mainMetadata?.main === true
        && mainMetadata?.deal === config.deal
        && returnedBar === expectedBar
        && Boolean(privateId);
      const rolesValid = gifts.length === ROLES.length && ROLES.every((role) => {
        return gifts.filter((item) => propertiesFor(item)[ROLE] === role).length === 1;
      });
      const giftsValid = rolesValid && gifts.every((item) => {
        const properties = propertiesFor(item);
        const role = properties[ROLE];
        const metadata = metadataFor(item);
        const dog = String(properties[dogProperty()] || '').trim();
        const phone = String(properties[phoneProperty()] || '').trim();
        const personalizationValid = role === 'gift_tags'
          ? !validationKey({ phone })
          : !dog && !phone;
        return itemMatchesIdentity(item, identityFor(config, role))
          && lineTotal(item) === 0
          && originalTotal(item) > 0
          && Number(item.quantity) === 1
          && (!parentKey(item) || parentKey(item) === String(main?.key || ''))
          && metadata?.deal === config.deal
          && String(metadata?.id || '') === privateId
          && metadata?.gift === expectedGiftIds[role]
          && personalizationValid;
      });
      const complete = validateConfig(config) && mainValid && giftsValid;
      if (complete) gifts.forEach((item) => validGiftKeys.add(item.key));
      else invalidGiftItems.push(...gifts);
      return { groupId, main, mains, gifts, complete };
    });
    const uniqueInvalidGiftItems = invalidGiftItems.filter(
      (item, index) => invalidGiftItems.indexOf(item) === index
    );
    return {
      groups,
      ordinaryItems: items.filter((item) => !validGiftKeys.has(item.key)),
      invalidGiftItems: uniqueInvalidGiftItems
    };
  };

  window.SafeWalkV6RealGiftContract = Object.freeze({
    validationKey,
    validateConfig,
    readRootConfig,
    configFromRoot,
    configFromRegistry,
    mainContractProperties,
    giftContractProperties,
    classifyCart
  });
})();
